import { render, staticRenderFns } from "./EditConfigurationHistoryComment.vue?vue&type=template&id=6b02647d&"
import script from "./EditConfigurationHistoryComment.vue?vue&type=script&lang=js&"
export * from "./EditConfigurationHistoryComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports